export const align_center = () => (
  <path
    d="M18 10H6m15-4H3m18 8H3m15 4H6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
